function replaceTokenWithDomain(app, pageDomain) {
    if (!app.url) {
        return app;
    }

    return Object.assign(app, {
        url: Array.isArray(app.url)
            ? app.url.map((url) => ({ url: url.url.replace('{{{domain}}}', pageDomain), name: url.name }))
            : app.url.replace('{{{domain}}}', pageDomain),
    });
}

export function parseAppDomainTokens(apps, pageDomain) {
    if (!pageDomain) {
        return;
    }

    return Array.isArray(apps)
        ? apps.map((app) => replaceTokenWithDomain(app, pageDomain))
        : replaceTokenWithDomain(apps, pageDomain);
}
